import {Box, Stack, Avatar} from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import {alpha, useTheme} from '@mui/material/styles';
import {bgGradient} from 'src/theme/css';

import {IUserProfileCover} from 'src/types/user';

// ----------------------------------------------------------------------

export default function ProfileCover({
  name,
  avatarName,
  avatarUrl,
  MRNLabel,
  coverUrl,
  renderPersonalInfo
}: IUserProfileCover) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        ...bgGradient({
          color: alpha(theme.palette.primary.darker, 0.8),
          imgUrl: coverUrl
        }),
        height: 1,
        color: 'common.white'
      }}>
      <Stack
        direction={{xs: 'column', md: 'row'}}
        sx={{
          left: {md: 24},
          bottom: {md: 24},
          zIndex: {md: 10},
          pt: {xs: 6, md: 0},
          position: {md: 'absolute'}
        }}>
        <Avatar
          alt={name}
          src={avatarUrl}
          sx={{
            mx: 'auto',
            width: {xs: 64, md: 128},
            height: {xs: 64, md: 128},
            border: `solid 2px ${theme.palette.common.white}`,
            fontSize: {xs: 24, md: 40}
          }}>
          {avatarName}
        </Avatar>

        <Stack>
          <ListItemText
            sx={{
              mt: 3,
              ml: {md: 3},
              textAlign: {xs: 'center', md: 'unset'}
            }}
            primary={name}
            secondary={MRNLabel}
            primaryTypographyProps={{
              typography: 'h4',
              fontSize: '1.2rem !important'
            }}
            secondaryTypographyProps={{
              mt: 0.5,
              ml: 0.5,
              color: 'inherit',
              component: 'span',
              typography: 'body2',
              sx: {opacity: 0.48}
            }}
          />
          {renderPersonalInfo()}
        </Stack>
      </Stack>
    </Box>
  );
}
